// The mapping rows for one pair of integrations, with the target-side schema
// resolved once for the whole card instead of per row.

import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

import { ArrowLabel, MappingCard, MappingCardHeader } from '../style';
import {
  headerKeysShape,
  integrationShape,
  mappingShape,
} from './formPropTypes';
import { locationAttributesOf } from './sharedSettingModel';
import MappingEntryRow from './MappingEntryRow';

const schemaMapOf = (integration) =>
  Object.fromEntries(locationAttributesOf(integration).map((a) => [a.name, a]));

const MappingPairCard = ({
  source,
  target,
  pairMappings,
  headerKeysByAttr,
  onChange,
}) => {
  const sourceSchemaMap = useMemo(() => schemaMapOf(source), [source]);
  const targetSchemaMap = useMemo(() => schemaMapOf(target), [target]);
  const targetOptions = useMemo(
    () =>
      locationAttributesOf(target).map((a) => ({
        id: a.name,
        label: a.name,
        value: a.name,
      })),
    [target],
  );

  return (
    <MappingCard>
      <MappingCardHeader>
        <span>{source.attributes.name}</span>
        <ArrowLabel>↔</ArrowLabel>
        <span>{target.attributes.name}</span>
      </MappingCardHeader>

      {pairMappings.map((mapping) => (
        <MappingEntryRow
          key={mapping.rowIdx}
          mapping={mapping}
          pairMappings={pairMappings}
          targetOptions={targetOptions}
          sourceSchemaMap={sourceSchemaMap}
          targetSchemaMap={targetSchemaMap}
          sourceIntegrationId={source.id}
          targetIntegrationId={target.id}
          headerKeysByAttr={headerKeysByAttr}
          onChange={onChange}
        />
      ))}
    </MappingCard>
  );
};

MappingPairCard.propTypes = {
  source: integrationShape.isRequired,
  target: integrationShape.isRequired,
  pairMappings: PropTypes.arrayOf(mappingShape).isRequired,
  headerKeysByAttr: headerKeysShape.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default memo(MappingPairCard);
